import React from 'react';

// Composant PDF Download Button
const PDFDownloadButton = ({ data, filename, caption, tableHeaders }) => {
    const handleDownload = async () => {
        try {
            // Import dynamique du composant PDF
            const { default: DashboardTablePDF } = await import('../../../components/DashboardTable/DashboardTablePDF');
            const { pdf, Document, Page } = await import('@react-pdf/renderer');

            // title doit être un array pour DashboardTablePDF
            const titleHeaders = Array.isArray(tableHeaders) ? tableHeaders : [];

            // Génération du PDF avec les bonnes props, enveloppé dans Document et Page
            const pdfDocument = (
                <Document>
                    <Page size="A4" orientation="landscape" style={{ padding: 30 }}>
                        <DashboardTablePDF
                            caption={caption || 'Rapport Dashboard'}
                            data={data || []}
                            title={titleHeaders}
                        />
                    </Page>
                </Document>
            );

            const pdfBlob = await pdf(pdfDocument).toBlob();

            // Téléchargement
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erreur lors de la génération du PDF:', error);
            alert('Erreur lors de la génération du PDF');
        }
    };

    return (
        <button
            className="pdf-download-btn"
            onClick={handleDownload}
            title={`Télécharger ${caption || 'le rapport'} en PDF`}
        >
            📄 PDF
        </button>
    );
};

export default PDFDownloadButton;
